// extracted by mini-css-extract-plugin
module.exports = {"modal_title":"CAMHistory_modal_title__2acvv","table":"CAMHistory_table__2-PZL","icon_button":"CAMHistory_icon_button__2h0M0","pendingStatus":"CAMHistory_pendingStatus__2SrGs"};